module.exports = __webpack_public_path__ + "static/media/ThePowerOfNatureGREEK.7be50e33.vtt";